export class UserContextModel {
	id?: string;
	firstName?: string;
	lastName?: string;
	name?: string;
	email?: string;
	isActive?: boolean;
	token?: string;
	loginMessage?: string;
	permission?: any;
	role?: Array<string>;
	loginFail?: boolean;
	isLoading?: boolean;
	navItems?: any;
	schema?: any;
	currentUrl?: string;
	currentModule?: string;
	requestPermissions?: RequestPermissions;
	cvConnection?: string;
	userName?: string;
	organizationName?: string;
	organizationId?: string;
	organizationType?: string;
	userType?: string;
	isPublicUser?: boolean;
}

export enum UserTypeModel  {
	INTERNAL = 'internal'
}

export class RequestPermissions {
	code: number;
	message: string;
}

export class RuleCounter {
	uiSection?: string;
	canSave?: boolean;
	check?: number;
}
